<template>
  <div>
    <el-form inline :model="form" class="search-demo" size="small">
      <el-form-item label="菜单名称：">
        <el-input v-model="form.name" placeholder="菜单名称"></el-input>
      </el-form-item>
      <el-form-item label="父级菜单：">
        <el-select
          v-model="form.parentMenuId"
          placeholder="选择父级菜单"
          clearable
        >
          <el-option
            v-for="item in parentArray"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div class="search_btn">
        <el-form-item>
          <el-button size="small" @click="resetForm()">清空</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="$emit('search', form)"
            size="small"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <!--  v-if="pagePermit.includes('_Add')" v-if="pagePermit.includes('_UpdateMenuPermit') -->
          <el-button
            type="primary"
            @click="$emit('opentitleForm')"
            icon="el-icon-plus"
            size="small"
            v-if="roleList[path].includes('_Add')"
            >新建菜单</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="$emit('openTree')"
            icon="el-icon-edit"
            size="small"
            v-if="roleList[path].includes('_Edit_permission')"
            >编辑权限</el-button
          >
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: ['parentArray', 'list'],
  data() {
    return {
      form: {
        name: '',
        parentMenuId: '',
      },
      path: '',
      fields: {
        名称: 'name',
        图标: 'icon',
        地址: 'url',
        描述: 'menuDesc',
        排序号: 'sortNum',
      },
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  methods: {
    resetForm() {
      this.form = {};
      this.$emit('search', this.form);
    },
  },
};
</script>
<style lang="less" scoped>
.topTitle {
  margin: 10px 0 30px 0;
}
.btn button {
  margin-left: 20px;
}
.search-demo {
  margin: 30px 0 10px 55px;
  input {
    height: 35px;
  }
}
.search_btn {
  float: right;
  margin-right: 20px;
}
</style>